import { BasicRequest } from "./basicRequest";

export class UndeleteAllocationDefinitionRequest extends BasicRequest{
    public allocationDefinitionId! : number;
}